﻿import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { resolveRawText } from '../Shared/Scripts/Utilities/EpiContentResolver';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import contentResolver from '../Shared/Scripts/Utilities/EpiContentResolver';
import RadioButtonsStegContainer from '../Shared/Scripts/Components/RadioButtonsStegComponent';
import Valg from '../Shared/Scripts/Models/Valg';
import ValgTillegg from '../Shared/Scripts/Models/ValgMedtillegg';
import { DisplayValue } from '../Shared/Scripts/Models/Valg';
import SkolePengerInputSteg from '../Shared/Scripts/Components/SkolePengerSteg';
import VelgUniversitetComponentVisning from '../Shared/Scripts/Components/VelgUniversitetComponent';
import LandOgUniversitetModel from '../Shared/Scripts/Models/LandOgUniversitetModel';

import VeilederUtvekslingDto from './Models/VeilederUtvekslingDto';
import { SatserUtlandModel } from './Models/SatserUtlandModel';
import { VeilederUtvekslingAppState } from './Store';
import * as ValgTypes from './Store/Valg/Types';
import { ResultatValg } from './Store/Resultat/Types';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import * as Ids from './Models/Ids';
import VarighetValg from './Utilities/VarighetValg';
import VerdensdelValg from './Utilities/VerdensdelValg';
import SelectOptionStegDisplay from '../Shared/Scripts/Components/SelectOptionStegComponent';
import UtregningFa from './Component/UtregningFa';
import UtregningFb from './Component/UtregningFb';
import Utbetalingsplan from './Component/UtbetalingsPlan';
import { registerAnalyticsEvent } from '../Shared/Scripts/Utilities/Analytics';

interface AppOwnProps {}
const RadioButtonsStegComponent = RadioButtonsStegContainer<VeilederUtvekslingDto>();
type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

const container = document.getElementById(Ids.AppContainerId)!;
ReactModal.setAppElement(container);

const analyticsState = { startet: false, fullfort: false };
const eventId = container.parentElement!.getAttribute('data-eventid');

interface AppState {}

class App extends React.Component<AppProps, AppState> {
    constructor(props: AppProps) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        const { valg, dispatchUpdateValg, epiContext, resultat, satser, universiteter } = this.props;
        const { epiModel, locale, valuta } = this.props.epiContext;

        function registerEvents(): void {
            if (!analyticsState.startet) {
                if (valg.aVarighet != undefined) {
                    analyticsState.startet = true;
                    registerAnalyticsEvent({ action: 'VeilederStart', eventId });
                }
            }

            if (!analyticsState.fullfort) {
                if (resultat.visBoksFa || resultat.visBoksFb) {
                    analyticsState.fullfort = true;
                    registerAnalyticsEvent({ action: 'VeilederFerdig', eventId });
                }
            }
        }

        function getLand(): DisplayValue[] {
            const items: DisplayValue[] = [];

            if (universiteter == null || universiteter == undefined || universiteter.length <= 0) return [];

            let annetLand: LandOgUniversitetModel | null = null;

            for (let i = 0; i < universiteter.length; i++) {
                if (universiteter[i].Kode === valg.bVerdensdel?.id) {
                    let erAlleredeLagtTilILandListen: boolean = false;
                    for (let x = 0; x < items.length; x++) {
                        if (items[x].id == universiteter[i].Landkode) erAlleredeLagtTilILandListen = true;
                    }

                    if (erAlleredeLagtTilILandListen) continue;

                    if (universiteter[i].Landkode === 'E') {
                        annetLand = universiteter[i];
                        continue;
                    }

                    if (locale === 'en-US') {
                        items.push({
                            id: universiteter[i].Landkode,
                            displayValue: universiteter[i].EngelskLandNavn,
                        });
                    } else {
                        items.push({
                            id: universiteter[i].Landkode,
                            displayValue: universiteter[i].LandNavn,
                        });
                    }
                }
            }

            let sorted: DisplayValue[] = items.sort(function (a, b) {
                var nameA = a.displayValue.toUpperCase();
                var nameB = b.displayValue.toUpperCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });

            if (annetLand !== null) {
                if (locale === 'en-US') {
                    sorted.push({
                        id: annetLand.Landkode,
                        displayValue: annetLand.EngelskLandNavn,
                    });
                } else {
                    sorted.push({
                        id: annetLand.Landkode,
                        displayValue: annetLand.LandNavn,
                    });
                }
            }

            return sorted;
        }

        function hentUniversiteterBasertPaLandValg() {
            let items: DisplayValue[] = [];

            if (valg.cLand?.id === 'E') {
                return items;
            }

            for (let i = 0; i < universiteter!.length; i++) {
                if (universiteter![i].Landkode === valg.cLand?.id) {
                    items.push({ id: universiteter![i].Universitet, displayValue: universiteter![i].Universitet });
                }
            }
            return items;
        }

        if (epiContext.epiModelFeilet) {
            return <FeilmeldingComponent />;
        }

        if (epiModel != null) {
            registerEvents()
            return (
                <div className="c-veileder">
                    <RadioButtonsStegComponent
                        sporsmalId={Ids.BoksA}
                        tittel={contentResolver(epiContext, 'tittelVarighet')}
                        forklaring={contentResolver(epiContext, 'infoVarighet')}
                        sporsmal="ledetekstVarighet"
                        valg={VarighetValg.varighetValg}
                        onInputChange={(nyttValg: Valg<string>): void => {
                            dispatchUpdateValg({ aVarighet: nyttValg });
                        }}
                        neverCollapse={true}
                        classModifier="c-veileder__panel--input-white"
                        value={valg.aVarighet}
                    />
                    {resultat.visBoksB && (
                        <RadioButtonsStegComponent
                            sporsmalId={Ids.BoksB}
                            tittel={contentResolver(epiContext, 'tittelVerdensdel')}
                            forklaring={<div>{contentResolver(epiContext, 'infoVerdensdel')}</div>}
                            sporsmal="ledetekstVerdensdel"
                            neverCollapse={false}
                            valg={VerdensdelValg.bValg}
                            onInputChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({
                                    bVerdensdel: nyttValg,
                                    cLand: undefined,
                                    visUtbetalingsplan: false,
                                    dSkolepenger: undefined,
                                });
                            }}
                            value={valg.bVerdensdel}
                        />
                    )}
                    {resultat.visBoksC && (
                        <SelectOptionStegDisplay
                            sporsmalId="land-velger-nedtrekk"
                            tittel={contentResolver(epiContext, 'tittelLand')}
                            options={getLand()}
                            forklaring={contentResolver(epiContext, 'infoLand')}
                            ledetekst={contentResolver(epiContext, 'ledetekstLand')}
                            onSelectChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ cLand: nyttValg, eUniversitet: undefined, visUtbetalingsplan: false, });
                            }}
                            value={valg.cLand}
                        />
                    )}
                    {resultat.visBoksD && (
                        <SkolePengerInputSteg
                            sporsmalId={Ids.BoksD}
                            tittel={contentResolver(epiContext, 'tittelSkolePenger')}
                            forklaring={contentResolver(epiContext, 'infoSkolePenger')}
                            ledetekst={contentResolver(epiContext, 'ledetekstSkolePenger')}
                            benevnelseForSkolepenger={contentResolver(epiContext, 'benevnelseForSkolepenger')}
                            valutaBenevnelse={valuta}
                            valgUkjentInputLedetekst={contentResolver(epiContext, 'valgSkolePengerUkjent')}
                            valgKnappTekst={contentResolver(epiContext, 'valgSkolePengerKnapp')}
                            onChange={(nyttValg: ValgTillegg<string>): void => {
                                dispatchUpdateValg({ dSkolepenger: nyttValg });
                            }}
                            value={valg.dSkolepenger}
                            visMerOmSkolePengerLenkeTekst={contentResolver(epiContext, 'merOmSkolePengerLenkeTekst')}
                            lukkSkolepengerPopupAriaTekst={resolveRawText(epiContext, 'lukkSkolepengerPopupAriaTekst')}
                            tittelMerSkolePengerTekst={contentResolver(epiContext, 'tittelMerSkolePengerTekst', 2)}
                            brodtekstMerSkolePengerTekst={contentResolver(
                                epiContext,
                                'brodtekstMerSkolePengerTekst',
                                2,
                            )}
                            locale={locale}
                            visBiCheckbox={true}
                            biLabel={resolveRawText(epiContext, 'biStudent')}
                        />
                    )}
                    {resultat.visBoksE && (
                        <VelgUniversitetComponentVisning
                            sporsmalId={'universitet-velger-nedtrekk'}
                            tittel={contentResolver(epiContext, 'tittelUniversitet')}
                            forklaring={contentResolver(epiContext, 'infoUniversitet')}
                            ledetekst={contentResolver(epiContext, 'ledetekstUniversitet')}
                            ingenValgTekst={resolveRawText(epiContext, 'ingenUniValgtVisningTekst')}
                            options={hentUniversiteterBasertPaLandValg()}
                            avhukingBoksTekst={contentResolver(epiContext, 'avhukingTekstUniversitet')}
                            onSelectChange={(nyttValg: Valg<string>): void => {
                                dispatchUpdateValg({ eUniversitet: nyttValg });
                            }}
                            value={valg.eUniversitet}
                            showSearch={true}
                        />
                    )}
                    {resultat.visBoksFa && (
                        <UtregningFa
                            tittelUtregning={contentResolver(epiContext, 'tittelUtregning')}
                            valg={valg}
                            satser={satser}
                            visUtbetalingsPlanHandler={(visPlan: boolean): void => {
                                dispatchUpdateValg({ visUtbetalingsplan: visPlan });
                            }}
                            valutaBenevnelseUtregning={valuta}
                            stipendVilkarTekst={contentResolver(epiContext, 'stipendVilkarTekst')}
                            stipendTittelUtregning={contentResolver(epiContext, 'stipendTittelUtregning')}
                            lanTittelUtregning={contentResolver(epiContext, 'lanTittelUtregning')}
                            tekstForLanOgStipendSomAlleFaar={contentResolver(
                                epiContext,
                                'tekstForLanOgStipendSomAlleFaar',
                            )}
                            tekstForDeMedSkolepenger={contentResolver(epiContext, 'tekstForDeMedSkolepenger')}
                            tekstForDeMedSkolepengerOgTilleggsstipend={contentResolver(
                                epiContext,
                                'tekstForDeMedSkolepengerOgTilleggsstipend',
                            )}
                            tekstForDeMedSkolepengerOgTilleggsstipendOgTilleggslan={contentResolver(
                                epiContext,
                                'tekstForDeMedSkolepengerOgTilleggsstipendOgTilleggslan',
                            )}
                            tekstForDeMedSkolepengerOgTilleggslan={contentResolver(
                                epiContext,
                                'tekstForDeMedSkolepengerOgTilleggslan',
                            )}
                            tekstForBiStudenterMedSkolepenger={contentResolver(
                                epiContext,
                                'tekstForBiStudenterMedSkolepenger',
                            )}
                            tekstForBiStudenterMed0Skolepenger={contentResolver(
                                epiContext,
                                'tekstForBiStudenterMed0Skolepenger',
                            )}
                            vilkarStudieStotteLenkeTekst={contentResolver(epiContext, 'vilkarStudieStotteLenkeTekst')}
                            vilkarStudieStotteTittel={contentResolver(epiContext, 'vilkarStudieStotteTittel')}
                            vilkarStudieStotteTekst={contentResolver(epiContext, 'vilkarStudieStotteTekst')}
                            vilkarLukkStudieStottePopupAriaTekst={resolveRawText(
                                epiContext,
                                'vilkarLukkStudieStottePopupAriaTekst',
                            )}
                            utbetalingsPlanLenkeTekst={contentResolver(epiContext, 'utbetalingsPlanLenkeTekst')}
                            locale={locale}
                            TekstForLanOgStipendSomAlleFaarOgTilleggsstipendUtveksling={contentResolver(
                                epiContext,
                                'tekstForLanOgStipendSomAlleFaarOgTilleggsstipendUtveksling',
                            )}
                            tekstForDeMedSkolepengerTilleggsstipendOgTilleggsstipendUtveksling={contentResolver(
                                epiContext,
                                'tekstForDeMedSkolepengerTilleggsstipendOgTilleggsstipendUtveksling',
                            )}
                            tekstForDeMedSkolepengerOgTilleggsstipendTilleggslanOgTilleggsstipendUtveksling={contentResolver(
                                epiContext,
                                'tekstForDeMedSkolepengerOgTilleggsstipendTilleggslanOgTilleggsstipendUtveksling',
                            )}
                            tekstForDeMedSkolepengerTilleggslanOgTilleggsstipendUtveksling={contentResolver(
                                epiContext,
                                'tekstForDeMedSkolepengerTilleggslanOgTilleggsstipendUtveksling',
                            )}
                            tekstForDeMedSkolepengerOgTilleggsstipendUtveksling={contentResolver(epiContext,
                                'tekstForDeMedSkolepengerOgTilleggsstipendUtveksling')}
                            eventId={eventId}
                        />
                    )}
                    {resultat.visBoksFb && (
                        <UtregningFb
                            tittelUtregning={contentResolver(epiContext, 'tittelUtregning')}
                            valg={valg}
                            satser={satser}
                            visUtbetalingsPlanHandler={(visPlanen: boolean): void => {
                                dispatchUpdateValg({ visUtbetalingsplan: visPlanen });
                            }}
                            valutaBenevnelseUtregning={valuta}
                            beskrivelseLanFb={contentResolver(epiContext, 'beskrivelseLanFb')}
                            overskriftLanFb={contentResolver(epiContext, 'overskriftLanFb')}
                            tekstForLanOgStipendSomAlleFaar={contentResolver(
                                epiContext,
                                'tekstForLanOgStipendSomAlleFaar',
                            )}
                            vilkarStudieStotteLenkeTekst={contentResolver(epiContext, 'vilkarStudieStotteLenkeTekst')}
                            vilkarStudieStotteTittel={contentResolver(epiContext, 'vilkarStudieStotteTittel')}
                            vilkarStudieStotteTekst={contentResolver(epiContext, 'vilkarStudieStotteTekst')}
                            vilkarLukkStudieStottePopupAriaTekst={resolveRawText(
                                epiContext,
                                'vilkarLukkStudieStottePopupAriaTekst',
                            )}
                            utbetalingsPlanLenkeTekst={contentResolver(epiContext, 'utbetalingsPlanLenkeTekst')}
                            locale={locale}
                            tekstForLanOgStipendSomAlleFaarOgTilleggsstipendUtveksling={contentResolver(
                                epiContext,
                                'tekstForLanOgStipendSomAlleFaarOgTilleggsstipendUtveksling',
                            )}
                            eventId={eventId}
                        />
                    )}
                    {resultat.visUtbetalingsplan && (
                        <Utbetalingsplan
                            satser={satser}
                            valg={valg}
                            resultat={resultat}
                            locale={locale}
                            valuta={valuta}
                        />
                    )}
                </div>
            );
        } else {
            return <div>Laster</div>;
        }
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederUtvekslingDto>;
    resultat: ResultatValg;
    satser: SatserUtlandModel | null;
    universiteter: Array<LandOgUniversitetModel> | null;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void;
}

const mapDispatchToProps = (
    dispatch: ThunkDispatch<VeilederUtvekslingAppState, {}, AnyAction>,
): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederUtvekslingAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
    satser: state.satser,
    universiteter: state.universiteter,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
